import type { Issue } from '@/lib/api/newsletter';
export function SignalContent({ issue }: { issue: Issue }) {
  return (
    <div>
      {issue.corrections.map((c, i) => (
        <aside
          key={i}
          style={{
            padding: 20,
            marginBottom: 24,
            border: '1px solid #d97706',
            borderRadius: 12,
          }}
        >
          <strong>Rettifica · {c.date}</strong>
          <p style={{ lineHeight: 1.7 }}>{c.text}</p>
          <a
            href={c.source_url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#60a5fa' }}
          >
            Fonte della rettifica →
          </a>
        </aside>
      ))}
      {!!issue.signals.length && (
        <>
          <p style={{ opacity: 0.8 }}>
            A cura di Luciano Ballerano · Periodo: {issue.period_start} —{' '}
            {issue.period_end} (fine esclusa)
          </p>
          {issue.editorial_intro && (
            <section
              style={{
                whiteSpace: 'pre-wrap',
                lineHeight: 1.8,
                margin: '28px 0',
              }}
            >
              {issue.editorial_intro}
            </section>
          )}
          {issue.editorial_checks.find((c) =>
            c.startsWith('Edizione breve: '),
          ) && (
            <p
              style={{
                padding: 20,
                marginBottom: 24,
                border: '1px solid rgba(128,128,128,.3)',
                borderRadius: 12,
              }}
            >
              {issue.editorial_checks.find((c) =>
                c.startsWith('Edizione breve: '),
              )}
            </p>
          )}
          <section aria-label="I segnali della settimana">
            {issue.signals.map((signal, i) => (
              <article
                key={signal.event_key || i}
                style={{
                  padding: 24,
                  marginBottom: 24,
                  border: '1px solid rgba(128,128,128,.3)',
                  borderRadius: 14,
                }}
              >
                <h2 style={{ fontSize: 23, fontWeight: 700, marginBottom: 16 }}>
                  {i + 1}. {signal.headline}
                </h2>
                <p style={{ lineHeight: 1.8, whiteSpace: 'pre-wrap' }}>
                  {signal.fact}
                </p>
                <h3 style={{ fontSize: 16, fontWeight: 700, marginTop: 18 }}>
                  Perché conta
                </h3>
                <p style={{ lineHeight: 1.8 }}>{signal.why_it_matters}</p>
                <h3 style={{ fontSize: 16, fontWeight: 700, marginTop: 18 }}>
                  Cosa valutare nel lavoro
                </h3>
                <p style={{ lineHeight: 1.8 }}>{signal.work_implication}</p>
                <h3 style={{ fontSize: 16, fontWeight: 700, marginTop: 18 }}>
                  Limiti e incertezze
                </h3>
                <p style={{ lineHeight: 1.8, opacity: 0.85 }}>
                  {signal.limits}
                </p>
                <ul style={{ marginTop: 18, paddingLeft: 20 }}>
                  {signal.sources.map((source) => (
                    <li key={source.url}>
                      <a
                        href={source.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#60a5fa' }}
                      >
                        {source.name}
                        {source.is_primary ? ' · fonte primaria' : ''}
                      </a>
                      {source.published_at ? ' · ' + source.published_at : ''}
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </section>
          {issue.practical_test && (
            <section
              style={{
                padding: 24,
                border: '1px solid #3b82f6',
                borderRadius: 14,
                marginBottom: 24,
              }}
            >
              <h2 style={{ fontSize: 22, fontWeight: 700 }}>
                Una prova concreta: {issue.practical_test.title}
              </h2>
              <p style={{ whiteSpace: 'pre-wrap', lineHeight: 1.8 }}>
                {issue.practical_test.instructions}
              </p>
              <p style={{ opacity: 0.85 }}>
                Limiti: {issue.practical_test.limits}
              </p>
              <ul>
                {issue.practical_test.sources.map((s) => (
                  <li key={s.url}>
                    <a
                      href={s.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#60a5fa' }}
                    >
                      {s.name}
                    </a>
                  </li>
                ))}
              </ul>
            </section>
          )}
        </>
      )}
    </div>
  );
}
